import { render, staticRenderFns } from "./AssignTokenModal.vue?vue&type=template&id=1fb4d89d&scoped=true"
import script from "./AssignTokenModal.vue?vue&type=script&lang=js"
export * from "./AssignTokenModal.vue?vue&type=script&lang=js"
import style0 from "./AssignTokenModal.vue?vue&type=style&index=0&id=1fb4d89d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb4d89d",
  null
  
)

export default component.exports